
export default function PositioningSection() {
  const comparisons = [
    {
      old: 'We fix broken PCs.',
      new: 'We maintain 100% clinical uptime.',
    },
    {
      old: 'We install antivirus.',
      new: 'We safeguard patient privacy and trust.',
    },
    {
      old: 'We help with HIPAA.',
      new: 'We de-risk the entire business entity.',
    },
    {
      old: 'We are a vendor.',
      new: 'We are an extension of your leadership team.',
    },
  ];

  return (
    <section id="approach" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            From Vendor to Strategic Partner
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We don't just fix problems—we transform how healthcare practices approach technology
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Table Header */}
          <div className="grid md:grid-cols-2 bg-gradient-to-r from-red-50 to-white">
            <div className="px-8 py-6 bg-red-50/70">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <i className="ri-close-circle-line text-red-500"></i>
                The Old Way (Expense)
              </h3>
            </div>
            <div className="px-8 py-6 bg-gradient-to-r from-red-50 to-red-100">
              <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-[#e10708]"></i>
                Your Way (Strategic Partner)
              </h3>
            </div>
          </div>

          {/* Table Rows */}
          {comparisons.map((item, index) => (
            <div
              key={index}
              className={`grid md:grid-cols-2 ${
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
              }`}
            >
              <div className="px-8 py-6 flex items-center gap-3">
                <i className="ri-close-line text-red-400 text-xl flex-shrink-0"></i>
                <p className="text-gray-600 italic">&quot;{item.old}&quot;</p>
              </div>
              <div className="px-8 py-6 flex items-center gap-3 border-l-2 border-[#e10708]">
                <i className="ri-check-line text-[#e10708] text-xl flex-shrink-0"></i>
                <p className="text-gray-900 font-semibold">{item.new}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
